import React from "react";
import styled from "styled-components";
import { Card, Empty, Progress, Space, Tag, Typography } from "antd";

const { Text } = Typography;

const WidgetCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
  }
`;

const StatusList = styled.div`
  display: grid;
  gap: 12px;
`;

const StatusRow = styled.div`
  border: 1px solid ${({ $bottleneck }) => ($bottleneck ? "#ffe58f" : "#f0f0f0")};
  border-radius: 8px;
  padding: 12px;
  background: ${({ $bottleneck }) => ($bottleneck ? "#fffbe6" : "#ffffff")};
`;

const StatusHeader = styled(Space)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const QuoteConversionWidget = ({ quoteConversion }) => {
  if (!hasQuoteConversionData(quoteConversion)) {
    return (
      <WidgetCard title="Quote Conversion">
        <Empty
          description="No quote conversion data for the selected filters"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </WidgetCard>
    );
  }

  const visibleStatuses = quoteConversion.statuses.filter(
    (status) => status.count > 0 || status.previousCount > 0 || status.isBottleneck
  );

  return (
    <WidgetCard
      title="Quote Conversion"
      extra={<Tag color="blue">{quoteConversion.total} quotes</Tag>}
      data-testid="quote-conversion-widget"
    >
      <StatusList>
        {visibleStatuses.map((status) => (
          <StatusRow
            key={status.status}
            $bottleneck={status.isBottleneck && status.count > 0}
            data-drilldown-key={status.drilldownKey}
          >
            <StatusHeader>
              <Space size={8} wrap>
                <Text strong>{status.label}</Text>
                {status.isBottleneck && <Tag color="orange">Bottleneck</Tag>}
              </Space>
              <Text strong>{status.count}</Text>
            </StatusHeader>
            <Progress
              percent={status.sharePercent}
              showInfo={false}
              strokeColor={status.isBottleneck ? "#faad14" : "#005249"}
            />
            <Space size={[8, 8]} wrap>
              <Text type="secondary">{status.sharePercent}% of quotes</Text>
              <Tag color={status.changeAbsolute > 0 ? "red" : "default"}>
                {formatChange(status.changeAbsolute)} vs previous
              </Tag>
            </Space>
          </StatusRow>
        ))}
      </StatusList>
    </WidgetCard>
  );
};

function hasQuoteConversionData(quoteConversion) {
  return quoteConversion?.statuses?.some(
    (status) => status.count > 0 || status.previousCount > 0
  );
}

function formatChange(value) {
  const numericValue = Number(value || 0);
  if (numericValue === 0) return "0";
  return numericValue > 0 ? `+${numericValue}` : String(numericValue);
}

export default QuoteConversionWidget;
